import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import i18n from '@/locales'
import 'vuetify/dist/vuetify.min.css'
import ChevronDownIcon from '@/components/icons/ChevronDownIcon.vue'
import AccountBalanceIcon from '@/components/icons/AccountBalanceIcon.vue'
import RoundedSquare from '@/components/icons/RoundedSquare.vue'
import RoundedSquareChecked from '@/components/icons/RoundedSquareChecked.vue'
import CheckIcon from 'vue-material-design-icons/Check.vue'
import InfoCircleOutline from '@/components/icons/InfoCircleOutline.vue'
import HelpCircleOutlineIcon from 'vue-material-design-icons/HelpCircleOutline.vue'

/**
 * S06 : presets : provides framework wide options and custom styling sass/scss
 * https://vuetifyjs.com/ko/customization/presets/
 */

Vue.use(Vuetify)

export default new Vuetify({
  rtl: false,
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  icons: {
    iconfont: 'mdiSvg',
    values: {
      chevrondown: {
        component: ChevronDownIcon // you can use string here if component is registered globally
      },
      accountbalance: {
        component: AccountBalanceIcon // you can use string here if component is registered globally
      },
      roundedsquare: {
        component: RoundedSquare
      },
      roundedsquarechecked: {
        component: RoundedSquareChecked
      },
      check: {
        component: CheckIcon,
        props: { size: 18}
      },
      helpcircleoutline: {
        component: HelpCircleOutlineIcon,
        props: { size: 16}
      },
      infocircleoutline: {
        component: InfoCircleOutline,
        props: { size: 15}
      }
    }
  },
  theme: {
    dark: false,
    default: 'dark',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: true,
      minifyTheme: undefined
    },
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      },
      dark: {
        primary: '#2196F3',
        secondary: '#424242',
        accent: '#FF4081',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      }
    }
  }
})
